module.exports = __webpack_public_path__ + "static/media/line-graph.331522aa.svg";